var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import { useComponentProps } from '../context/component-props-context';
var cls = classNames('app-dialog-controls');
export var AppDialogControlsDefaultProps = {};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    background: ", ";\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    border-radius: 0 0 ", " ", ";\n\n    ", "\n  "], ["\n    background: ", ";\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    border-radius: 0 0 ", " ", ";\n\n    ", "\n  "])), theme.COLOR('app-chrome'), theme.UNIT(2), theme.UNIT(2), function (_a) {
    var centerControls = _a.centerControls;
    return centerControls && css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      justify-content: center;\n    "], ["\n      justify-content: center;\n    "])));
  })
});
var ControlsStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    padding: ", " ", " ", ";\n    gap: ", ";\n    display: flex;\n  "], ["\n    padding: ", " ", " ", ";\n    gap: ", ";\n    display: flex;\n  "])), theme.UNIT(4, -2), theme.UNIT(4), theme.UNIT(4), theme.UNIT(3))
});
var StartStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    ", ";\n  "], ["\n    ", ";\n  "])), ControlsStyles)
});
var EndStyles = breakpoints({
  base: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    ", ";\n  "], ["\n    ", ";\n  "])), ControlsStyles)
});
// -------- Components -------->
var My = {
  NAME: 'AppDialogControls',
  Container: styled.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Start: styled.div(templateObject_7 || (templateObject_7 = __makeTemplateObject(["", ""], ["", ""])), StartStyles),
  End: styled.div(templateObject_8 || (templateObject_8 = __makeTemplateObject(["", ""], ["", ""])), EndStyles)
};
export var AppDialogControls = function (props) {
  var componentProps = useComponentProps(My.NAME, AppDialogControlsDefaultProps, props);
  var className = componentProps.className,
    children = componentProps.children,
    start = componentProps.start,
    end = componentProps.end;
  var onlyStart = start && !end;
  return React.createElement(My.Container, {
    className: cls.name(className),
    centerControls: onlyStart
  }, React.createElement(My.Start, null, start), React.createElement(My.End, null, end));
};
AppDialogControls.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8;